import React, { useEffect, Fragment, useState, useRef } from 'react'
import axios from 'axios'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap'
import { ReactComponent as PhoneCallIcon } from '../../../assets/icons/phone-call.svg'
import { ReactComponent as IncomingCallIcon } from '../../../assets/icons/incoming-call.svg'
import { ReactComponent as EmailIcon } from '../../../assets/icons/email.svg'
import { ReactComponent as MeetingIcon } from '../../../assets/icons/meeting.svg'
import { ReactComponent as TextMessageIcon } from '../../../assets/icons/text_message.svg'
import { ReactComponent as SharedNoteIcon } from '../../../assets/icons/shared_note.svg'
import { clearTimelineData, getTimelineData } from './redux/activitiesTimelineActions'
import Filters from './FiltersTimeline'
import CustomModal from '../../CustomModal/CustomModal'
import { formatDateWithTimezone } from '../../../utils/utcTime'
import {
  DIRECT_MAIL,
  EMAIL,
  INCOMING_CALL,
  MEETING,
  OUT_GOING_CALL,
  SHARED_NOTE,
  TEXT_MESSAGE,
} from '../../../constants/activityTypes'
import './ActivitiesTimeline.scss'
import InfiniteScroll from 'react-infinite-scroll-component'
import AttachmentList from '../ContactHistoryTabs/components/AttachmentList'

const ActivitiesTimeline = ({
  activities,
  divisions,
  clearTimelineData,
  contactId,
  showFilters,
  query,
  getTimelineData,
}) => {
  const [filterValues, setFilterValues] = useState({
    allActivities: false,
    activities: true,
    myActivities: false,
    myTeamActivities: false,
    division: [],
    activityType: [],
  })

  const [selectValues, setSelectValues] = useState({
    divisionOptions: [],
    activityTypeOptions: [],
  })

  const [modalSeeFullNotes, setModalSeeFullNotes] = useState({
    isOpen: false,
    notes: '',
  })

  const scrollableRef = useRef(null)

  const resetScrollPosition = () => {
    if (scrollableRef?.current) {
      scrollableRef.current.scrollTop = 0
    }
  }

  useEffect(() => {
    if (
      filterValues.division.length === 0 &&
      !filterValues.myActivities &&
      !filterValues.myTeamActivities &&
      !filterValues.allActivities
    ) {
      setFilterValues({ ...filterValues, activities: true })
    }
  }, [filterValues.myActivities, filterValues.myTeamActivities, filterValues.division, filterValues.allActivities])

  useEffect(() => {
    loadData()
    loadSelectValues()

    return () => {
      clearTimelineData()
    }
  }, [])

  const loadData = () => {
    let filter = {
      allActivities: filterValues.allActivities,
      activities: filterValues.activities,
      myActivities: filterValues.myActivities,
      myTeamActivities: filterValues.myTeamActivities,
      division: filterValues.division.length > 0 && filterValues.division,
      activityType: filterValues.activityType.length > 0 && filterValues.activityType,
      contactId,
    }
    getTimelineData(filter, { first: 0, limit: query.limit }, true)
  }

  const fetchMore = () => {
    const filter = {
      allActivities: filterValues.allActivities,
      activities: filterValues.activities,
      myActivities: filterValues.myActivities,
      myTeamActivities: filterValues.myTeamActivities,
      division: filterValues.division.length > 0 && filterValues.division,
      activityType: filterValues.activityType.length > 0 && filterValues.activityType,
      contactId,
    }
    const { first, limit } = query
    getTimelineData(filter, { first: first + limit, limit }, false)
  }

  const loadSelectValues = async () => {
    const divisionOptions = [],
      activityTypeOptions = []
    divisions.data &&
      divisions.data.forEach((division) =>
        divisionOptions.push({
          label: division.name,
          value: division.id,
        })
      )

    const responseActivityType = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: 8 } },
    })
    responseActivityType.data.data.forEach((activity) =>
      activityTypeOptions.push({
        label: activity.name,
        value: activity.id,
      })
    )

    setSelectValues({ divisionOptions, activityTypeOptions })
  }

  const onChangeSwitches = (e) => {
    const { name, value } = e.target
    setFilterValues({
      ...filterValues,
      allActivities: false,
      activities: false,
      myActivities: false,
      myTeamActivities: false,
      division: [],
      [name]: value,
    })
  }

  const onChangeSelect = (value, e) => {
    const { name } = e
    const newSelectedValue = []
    if (value) {
      value.forEach((value) => {
        newSelectedValue.push(value.value)
      })
      if (name === 'division') {
        setFilterValues({
          ...filterValues,
          allActivities: false,
          activities: false,
          myActivities: false,
          myTeamActivities: false,
          division: [],
          [name]: newSelectedValue,
        })
      } else setFilterValues({ ...filterValues, [name]: newSelectedValue })
    } else {
      setFilterValues({ ...filterValues, [name]: [] })
    }
  }

  const onSearchClick = () => {
    loadData()
    resetScrollPosition()
  }

  const onSeeFullNotesClick = (notes) => {
    setModalSeeFullNotes({
      isOpen: !modalSeeFullNotes.isOpen,
      notes: notes || '',
    })
  }

  const endMessage = query.totalRecords > 0 && (
    <div className={'mt-2 mb-2 end_container'}>
      <h6 style={{ fontStyle: 'italic' }}>No more activities available!</h6>
    </div>
  )

  const composeIconBackgroundColor = (activityType) => {
    switch (activityType) {
      case EMAIL:
      case DIRECT_MAIL:
        return '#ff7450'
      case MEETING:
        return '#4ca3dd'
      case INCOMING_CALL:
        return '#d640d3'
      case OUT_GOING_CALL:
        return '#522888'
      case TEXT_MESSAGE:
        return 'goldenrod'
      case SHARED_NOTE:
        return 'green'
      default:
        return 'grey'
    }
  }

  return (
    <Fragment>
      <CustomModal isOpen={modalSeeFullNotes.isOpen} toggle={onSeeFullNotesClick} headerText={'Full Notes'}>
        <Row>
          <Col>
            <div
              dangerouslySetInnerHTML={{
                __html: modalSeeFullNotes.notes,
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button size='sm' color='danger' onClick={onSeeFullNotesClick} className='float-right'>
              Close
            </Button>
          </Col>
        </Row>
      </CustomModal>
      {showFilters && (
        <Row>
          <Col>
            <Filters
              values={filterValues}
              onChangeSwitches={onChangeSwitches}
              selectValues={selectValues}
              onChangeSelect={onChangeSelect}
              onSearchClick={onSearchClick}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <Card>
            <CardHeader>Timeline</CardHeader>
            <CardBody className='vertical-timeline-custom' innerRef={scrollableRef} id={'scrollableTimeline'}>
              <Row>
                <Col>
                  <InfiniteScroll
                    dataLength={activities.length}
                    next={fetchMore}
                    hasMore={query.hasMore}
                    loader={<h6>loading...</h6>}
                    endMessage={endMessage}
                    scrollableTarget='scrollableTimeline'
                    scrollThreshold={0.8}
                  >
                    <VerticalTimeline>
                      {Array.isArray(activities) &&
                        activities?.map((activity, index) => {
                          let icon = null
                          let activityName = activity.activityTypeData.name
                          if (activity.activityTypeData.id === OUT_GOING_CALL) icon = <PhoneCallIcon />
                          else if (activity.activityTypeData.id === TEXT_MESSAGE) icon = <TextMessageIcon />
                          else if (
                            activity.activityTypeData.id === EMAIL ||
                            activity.activityTypeData.id === DIRECT_MAIL
                          )
                            icon = <EmailIcon />
                          else if (activity.activityTypeData.id === MEETING) icon = <MeetingIcon />
                          else if (activity.activityTypeData.id === INCOMING_CALL) icon = <IncomingCallIcon />
                          else if (activity.activityTypeData.id === SHARED_NOTE) icon = <SharedNoteIcon />
                          return (
                            <VerticalTimelineElement
                              key={`${activity.id}=${index}`}
                              className='vertical-timeline-element--work'
                              contentArrowStyle={{
                                background: 'transparent',
                              }}
                              iconStyle={{
                                background: composeIconBackgroundColor(activity.activityTypeData.id),
                                color: '#fff',
                                fill: '#fff',
                              }}
                              icon={icon}
                            >
                              <h3 className='timeline-subject'>
                                {/* <span className='timeline-subject__subject'>Subject: </span> */}
                                {activity.subject}
                                {activity.callData?.transferred && (
                                  <span className='ml-2' title='Call was transferred'>
                                    <i className='fas fa-exchange-alt' style={{ color: '#007bff' }} />
                                  </span>
                                )}
                              </h3>
                              <p className='timeline-follow-up'>
                                <span>
                                  <i className='far fa-hand-point-right mr-1' />
                                  {activity?.followUp === 0 ? 'Initial' : `Follow Up: ${activity?.followUp}`}
                                </span>
                                <span>
                                  <AttachmentList size='sm' attachments={activity.attachments || []} />
                                </span>
                              </p>
                              <p className='timeline-activity-type'>
                                {icon && <div>{icon}</div>}
                                {activityName}
                              </p>
                              <p className='timeline-notes'>
                                {/* <span className='timeline-notes__headline'>Notes: </span> */}
                                <div
                                  ref={(el) => {
                                    if (el) {
                                      if (el.offsetHeight > 75) {
                                        el.style.height = '75px'
                                        const div = document.createElement('div')
                                        div.classList.add('seeFullNotes')
                                        const button = document.createElement('button')
                                        button.classList.add('button-full-notes')
                                        button.onclick = function () {
                                          return onSeeFullNotesClick(activity.notes)
                                        }
                                        const textButton = document.createTextNode('See full notes')
                                        button.appendChild(textButton)
                                        div.appendChild(button)
                                        el.appendChild(div)
                                      }
                                    }
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: activity.notes,
                                  }}
                                  className='timeline-notes__notes'
                                />
                              </p>
                              <div
                                className={`date-name-info ${
                                  index % 2 === 0 ? 'date-name-info__left' : 'date-name-info__right'
                                }`}
                              >
                                <span className='date-name-info__name'>
                                  {activity.userName} - {activity.userDivision}
                                </span>
                                <span className='date-name-info__date mb-1'>
                                  <i className='fa fa-calendar mr-1' aria-hidden='true'></i>
                                  {formatDateWithTimezone(activity.creationDate, 'YYYY-MM-DD')}
                                </span>
                                <span className='date-name-info__date-time mb-1'>
                                  <i className='fa fa-clock-o' aria-hidden='true'></i>{' '}
                                  {formatDateWithTimezone(activity.creationDate, 'hh:mm A')}
                                </span>
                                <span className='date-name-info__call'>
                                  {activity.callData.duration ? (
                                    <>
                                      CALL DURATION: <span>{activity.callData.duration} SECONDS</span>
                                      {activity.callData.transferred && (
                                        <span className='ml-2' title='Call was transferred'>
                                          <i className='fas fa-exchange-alt' style={{ color: '#007bff' }} />
                                        </span>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </span>
                              </div>
                            </VerticalTimelineElement>
                          )
                        })}
                    </VerticalTimeline>
                  </InfiniteScroll>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  )
}

ActivitiesTimeline.propTypes = {
  getTimelineData: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  activities: PropTypes.array.isRequired,
  divisions: PropTypes.object.isRequired,
  clearTimelineData: PropTypes.func.isRequired,
  contactId: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => ({
  activities: state.contactActivitiesTimeline.activitiesTimelineData,
  query: state.contactActivitiesTimeline.query,
  divisions: state.divisions.divisions,
})

export default connect(mapStateToProps, { clearTimelineData, getTimelineData })(ActivitiesTimeline)
